import { render, staticRenderFns } from "./MaterialDownloader.vue?vue&type=template&id=c67feb80&"
import script from "./MaterialDownloader.vue?vue&type=script&lang=js&"
export * from "./MaterialDownloader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports